import type { QuestionChoice } from '@exam-management/graphql';
import { DoneIcon, Flex, Text, styled, type FlexProps } from '@shared/components';
import { useMemo } from 'react';

import { QuestionReviewContentPreviewer } from '../question-review-content-previewer';

const QuestionChoiceListWrapper = styled(Flex)({ flexDirection: 'column' });

const QuestionChoiceListItemWrapper = styled(Flex)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.shape.rounded(1),
  gap: theme.spacing(2.5),
}));

interface QuestionChoiceListProps {
  choices: QuestionChoice[];
  value: string;
  questionId: string;
  taskId: string;
  sx?: FlexProps['sx'];
}

export default function QuestionReviewChoiceList(props: Readonly<QuestionChoiceListProps>) {
  const { choices, questionId, taskId, value, ...restProps } = props;

  const orderedChoices = useMemo(() => [...choices].sort((a, b) => a.order - b.order), [choices]);

  return (
    <QuestionChoiceListWrapper {...restProps}>
      {orderedChoices.map((choice) => {
        const { value: choiceValue, label, order } = choice;
        const isCorrect = value === choiceValue;

        return (
          <QuestionChoiceListItemWrapper
            key={choiceValue}
            sx={{ backgroundColor: isCorrect ? 'success.light' : 'unset' }}
          >
            <DoneIcon
              color='success'
              sx={{ visibility: isCorrect ? 'visible' : 'hidden', height: 24, width: 24 }}
            />
            <Text sx={{ flexShrink: 0 }}>{order}.</Text>
            <QuestionReviewContentPreviewer
              content={label}
              questionId={questionId}
              taskId={taskId}
            />
          </QuestionChoiceListItemWrapper>
        );
      })}
    </QuestionChoiceListWrapper>
  );
}
